import upng from 'upng-js';
import {FrameSize} from '../type/FrameSize.interface';

/**
 * 빈 PNG 파일을 만드는 함수
 *
 * debug가 false면 투명한 이미지, true면 rgba(255, 0, 0, 0.5) 색상의 이미지를 만듭니다.
 */
export function createEmptyImageDataUri(
  {width, height}: FrameSize,
  debug?: boolean
) {
  const bufferLength = width * height * 4;
  const data = new Uint8ClampedArray(bufferLength);
  if (debug) {
    for (let y = 0; y < height; y++) {
      for (let x = 0; x < width; x++) {
        const p = (x + y * width) * 4;
        data[p] = 255;
        data[p + 1] = 0;
        data[p + 2] = 0;
        data[p + 3] = 128;
      }
    }
  }
  const png = upng.encode([data.buffer], width, height, 1);
  return (
    'data:image/png;base64,' +
    window.btoa(String.fromCharCode(...new Uint8Array(png)))
  );
}
